import { UiIntegrationSectionModel } from "../../models";

import { mockRouteModel } from ".";

export function mockUiIntegrationSectionModel({
    id = "integration-section-1234",
    type = "uiIntegrationSection",
    locale = "en",
    content = mockUiIntegrationSectionModelContent()
}: Partial<UiIntegrationSectionModel> = {}): UiIntegrationSectionModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiIntegrationSectionModelContent =
    UiIntegrationSectionModel["content"];

export function mockUiIntegrationSectionModelContent({
    entryTitle = "Integration Section Example",
    searchLabel = "Search all integrations",
    filterByText = "Filter by:",
    viewAllButtonText = "View all",
    viewLessButtonText = "View less",
    allIntegrationsTitle = "All integrations",
    allIntegrationsRoute = mockRouteModel(),
    allIntegrations = [],
    ...optionals
}: Partial<UiIntegrationSectionModelContent> = {}): UiIntegrationSectionModelContent {
    return {
        entryTitle,
        searchLabel,
        filterByText,
        viewAllButtonText,
        viewLessButtonText,
        allIntegrationsTitle,
        allIntegrationsRoute,
        allIntegrations,
        ...optionals
    };
}
